import {ContentGroup} from './content-group.model';
import {ContentMediaFile} from './content-media-file.model';
import {ContentPoster} from './content-poster.model';
import {Content} from './content.model';
import {Category} from './cms-vod-core/category.model';
import {Metadata} from './metadata.model';
import {VideoOperationProcess} from './vod-operations/video-operation-process-model';

export class ComingSoonContent {
  constructor(
    public content?: Content,
    public contentGroup?: ContentGroup,
    public contentMediaFiles?: ContentMediaFile[],
    public guid?: string,
    public id?: number,
    public isValidPoster?: boolean,
    public labels?: Category[],
    public name?: string,
    public posters?: ContentPoster[],
    public publishTime?: number,
    public unpublishTime?: number,
    public planStartTime?: number,
    public creationDate?: number,
    public planEndTime?: number,
    public status?: string,
    public trailerOperationFailed?: boolean,
    public trailerOperationProcessName?: string,
    public trailerOperationProcesses?: VideoOperationProcess[],
    public metadata?: Metadata,
    public isValidMetadata?: boolean,
    public planned?: boolean,
    public trailerAssignee?: string,
    public isExternal?: boolean,
    public comingSoonCompletionTime?: number,
    public trailerSnapshotFileName?: string,
    public onlineEditorAssignee?: string
  ) {
  }
}
